var xmega = function () { };

xmega.prototype = {
    init: function (el) {
        var me = this;
        me.el = el;
        me.render(el);
        me.listeners();
        me.ajax.init(me);
    },
    render: function (el) {
        var me = this;
        me.details = el.find('.fieldText');
        me.xinput = el.find('input.mainText');
        me.xtext = el.find('span.fieldText');
        me.xtextVal = me.xinput.val();
        me.contentBox     = el.siblings('.contentBox');
        me.contentBoxList = me.details.closest('.form-control').siblings('div.contentBox.list');
        me.contentBoxComp = me.details.closest('.form-control').siblings('div.contentBox.comp');
        me.document = $(document);
        me.dataset = el.find('.input-group').data('dataset');
        el.addClass('rendered');
    },
    listeners: function (el) {
        var me = this;
        me.details.on('click', function (e) {
            e.stopPropagation();
			me.ajax.detail();
			
			$(document).one('click', function(e) {
				me.contentBoxComp.removeClass('active');
				me.contentBoxComp.hide();
			});
        });
        // On xmega click
        // me.el.on('click', function (e) {
		// 	e.stopPropagation();
        //     let data = $(this).data(),
        //         term = data.term,
        //         id = data.id,
        //         name = data.name;
        //     // var checkIfRendered = me.contentBoxList.hasClass('rendered');
        //     // if (checkIfRendered === true) {
        //     //     return;
        //     // }
        //     me.xinput.val(null);
        //     me.contentBoxComp.add(me.details).removeClass('active').hide();
        //     // Change to ajax function!!
        //     me.ajax.open();
		// });
		me.el.on('click', function(e) {
			e.stopPropagation();
						
			me.contentBoxComp.hide();
			me.contentBoxComp.removeClass('active');
			me.details.hide();

			me.contentBoxList.addClass('active');

            var checkIfRendered = me.contentBoxList.hasClass('rendered');
			if (checkIfRendered === true){
				var oldValue = me.xinput.val();

				me.contentBoxList.show();
				me.xinput.val(null);
				me.xinput.show().focus();

				$(document).one('click', function(e) {
					me.contentBoxList.removeClass('active');
					me.contentBoxList.hide();
					
					me.xinput.val(oldValue);
					
					me.xinput.hide();
					me.details.show();
				});

				// Close Button
				me.contentBoxList.find('.header').find('.btn-close i').on('click', function(e) {
					e.stopPropagation();
					me.xinput.val(oldValue);

					me.contentBoxList.removeClass('active');
					me.contentBoxList.hide();
					me.details.show();
					me.xinput.hide();
				});
				return;
			}
            me.contentBoxComp.add(me.details).removeClass('active').hide();
			
			var oldValue = me.xinput.val();
			me.xinput.val(null);
			
			$(document).one('click', function(e) {
				me.contentBoxList.removeClass('active');
				me.contentBoxList.hide();
				if(!me.xinput.val()) {
					me.xinput.val(oldValue);
				}
				me.xinput.hide();
				me.details.show();
			});
			
			// Change to ajax function!!
			me.ajax.open(checkIfRendered, oldValue);
        });

        // On keyup input 'Search' {100ms delay}

        var delay = xhelper.keypress.delay(100);
        me.xinput.keyup(function (e) {
            var inputValue = $(this).val();
            delay(function () {
                me.ajax.search(inputValue);
            });
        });
        // On data click
        me.contentBoxList.on('click', 'tbody tr', function (e) {
			e.stopPropagation();

            let data = $(this).data(),
                id = data.id,
                text = data.name
			
			if (!id) throw "XMEGA - nenurodytas ID";
            me.xinput.val(id).hide();
            me.xtext.html(text);
            me.contentBoxList.hide();
            me.details.show();
        });

        // Filters click
        me.contentBoxList.on('click', 'thead th', function (e) {
            let selectedValue = $(this).attr('data-key'),
                clickedRow = this,
                checkIfRendered = me.contentBoxList.hasClass('rendered'),
                attr = $(this).attr('data-filter'),
                filterVal;

            // Check ASC or DSC
            if (attr == 'ASC') {
                $(this).attr('data-filter', 'DESC');
                attr = 'DESC';
            } else {
                $(this).attr('data-filter', 'ASC');
                attr = 'ASC';
            }

            me.ajax.sort({
                filter: selectedValue,
                filterVal: attr,
                rendered: checkIfRendered,
                clickedRow: clickedRow
            });
        });
        me.document.one('click', function (e) {
            me.contentBox.add(me.xinput).removeClass('active').empty().hide();
            me.contentBoxList.hide();
            me.details.show();
        });
        // Close Button
        me.contentBoxList.on('click', '.xmegaClose', function (e) {
            e.stopPropagation();
            me.contentBox.add(me.xinput).removeClass('active').empty().hide();
            me.contentBoxList.hide();
            me.details.show();
            // me.details.val(' ');
            // me.contentBoxList.hide();
            // me.xinput.val();
            // me.xinput.hide();

            // me.contentBoxComp.add(me.details).removeClass('rendered').hide();
        });
	},
    ajax: {
        init: function (me) {
            var ajax = this;
            ajax.parent = me;
            ajax.config = {
                url: '/xmega',
                type: 'POST',
                data: {
                    _xmega: me.dataset
                },
                dataType: 'html',
                success: function (response) {
                    ajax.callback(response);
                }
            };
        },
        load: function () {
            this.loading = true;
            $.ajax(this.config);
        },
        open: function (checkIfRendered) {
            var ajax = this,
                me = ajax.parent;
            ajax.config.data.type = 'open';
            ajax.callback = function (response) {
                me.contentBoxList.add(me.xinput).addClass('active').show().focus();
                me.contentBoxList.addClass('rendered');
				
                // if (!checkIfRendered) {
                //     me.contentBoxList.html(response);
                // } else {
                //     //$(me.contentBoxList).find('tbody').html(response);
                //     me.contentBoxList.html(response);
				// }
				me.contentBoxList.html(response);

                xlisteners.init();
            };

            ajax.load();
        },
        detail: function () {
            var ajax = this,
                me = ajax.parent;

            ajax.config.data.type = 'detail';
            console.log(me);
            ajax.config.data.id = me.xinput.val();
            //ajax.config.data._xmega = 'detail';

            console.log(ajax.config)

            ajax.callback = function (response) {
                me.contentBoxComp.html(response);
                me.contentBoxComp.addClass('active').show();
            };
            ajax.load();
        },

        search: function (term) {
            var ajax = this,
                me = ajax.parent;
            ajax.config.data.type = 'search';
            ajax.config.data.term = term;
            ajax.config.data.style = true;
            ajax.callback = function (response) {
                if (term.length >= 2) {
					me.contentBoxList.find('tbody')
						.html(response.replace(RegExp(term, "g")
							, "<span style='background-color: yellow; border: solid 1px black'>" + term + "</span>"));
                }
                else {
                    me.contentBoxList.find('tbody').html(response);
                }
                if (!/\S/.test(response)) {
                    $('#buttonas').show();
                    //$('#buttonas2').addClass("text-right");
                } else {
                    $('#buttonas').hide();
                    //$('#buttonas2').removeClass("text-right");
                }
            };
            ajax.load();
        },

        sort: function (data) {
            var ajax = this,
                me = ajax.parent;
            ajax.config.data.type = 'sort';
            ajax.callback = function (response) {
                $(me.contentBoxList).find('tbody').html(response);
                data.filterVal == "ASC" ? $(data.clickedRow).find('i').removeClass('fa fa-angle-up').addClass('fa fa-angle-down') : $(data.clickedRow).find('i').removeClass('fa fa-angle-down').addClass('fa fa-angle-up');
            };
            ajax.load();
        }
    }
}